/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Social media
#Map
#FAQ

/*============================================================================
  Featured collection
==============================================================================*/

var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": false,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}

/*============================================================================
  Featured promotions
==============================================================================*/
// var aos_animate = {
//   init: function(){
//  	AOS.init({
//       once: true,
//       offset: 120,
//       duration: 1000,
//       disable: 'phone'
//     }); 	
//   },
//   unload: function(){

//   }
// }

/*============================================================================
  Featured promotions
==============================================================================*/
var featuredPromotions = {
  init: function(){
    if ($(window).width() > 798 || $(window).width() == 0) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height')
      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
          adaptiveHeight: settings.adaptiveHeight,
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: false,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize
        });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'select.flickity', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
            buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Testimonials
==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: false,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize
        });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'select.flickity', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
            buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

/*============================================================================
  Gallery
==============================================================================*/

var gallery = {
  init: function(){

    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
      var wrapper = $(this);
      var images = $(this).find("img");
      var imgWidth,
          imgHeight;

      $("<img />").attr("src", $(images).attr("src")).on('load', function() {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
        $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
        $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
      });
    });

    $('[rel=gallery]').fancybox({
      baseClass: "gallery-section__lightbox",
      clickContent: "nextOrClose"
    })

  }
}

/*============================================================================
  Video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Initialize lazy videos
    lazyframe('.lazyvideo--autoplay--true', {
      initinview: true,
    });

    lazyframe('.lazyvideo--autoplay--false', {
      initinview: false,
    });

    //Wrap product description iframes in responsive lazyframe div
    $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');

    function hideTextElements(parent) {
      parent.find('.caption').hide();
      parent.find('.action_button').hide();
    }

    var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
    hideTextElements(videoElement);


    if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
      var videoSection = $('.js-video').parents('.js-video-section');
      hideTextElements(videoSection);
    }

    $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
      var videoSection = $(this).parents('.js-video-section');
      hideTextElements(videoSection);
    })

    $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
      //Target parent lazyframe
      var videoSection = $(this).parents('.js-video-section');
      var lazyElement = videoSection.find('.lazyframe');
      var videoWrapper = videoSection.find('.js-video');
      if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
        videoSection.find('video')[0].play();
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      } else{
        //create iframe and add settings
        var lazyIframe = document.createElement('iframe');
        iframeSrc = lazyElement.data('src');
        cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
        lazyIframe.src = cleanIframeSrc;
        lazyIframe.setAttribute('allowfullscreen', true);
        lazyIframe.setAttribute('frameborder', 0);
        //Append iframe to lazyframe
        lazyElement.append(lazyIframe);
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      }
    });
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
    $target.find('video.hide-text-on-video').off('click');
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "You must agree with the terms and conditions to checkout." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }

    //Refresh page on add to cart if on cart page
    if($('body').hasClass('cart')) {
      $('.product_form form').on("submit", function(){
        setTimeout(function(){
          document.location.href = "/cart";
        }, 500);
      });
    }
  }
}

/*============================================================================
  Product
==============================================================================*/

selectCallback = function(variant, selector) {

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');
  var material_label = $('.material-label');

  var $notifyFormInputs = $('.notify_form__inputs');

  var notifyEmail = "Enter your email address...";
  var notifyEmailValue = "";
  var notifySend = "Send";

  var notifyUrl = $notifyFormInputs.data('url');
  
  if(variant && variant.options.length > 0){
  	material_label.text(variant.option1);
  }

  if (variant) {
    var notifyMessage = "Please notify me when "+variant.title+" becomes available - "+notifyUrl;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="'+ notifyCustomerEmail +'" />'
    } else {
      var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ notifyEmail +'" value="'+ notifyEmailValue +'" />';
    }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="action_button" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $sliderInstance.select( index, false, true );
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    
    for (var i=0,length=variant.options.length; i<length; i++) {
      var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
      if (radioButton.length) {
        radioButton.get(0).checked = true;
      }
    }
    
  }

  if (variant && variant.available == true) {
    if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html("You Save" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    $('.variant-avility-state', $product).text(''); // text that displays when product is in stock and available 
    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    } else {
      $('.current_price', $product).html("Free");
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
    $notifyFormInputs.empty();
    $('.notify-oos').hide();
    $('.buynow-checkout-btn', $product).show();

  } else {
      var message = variant ? "Sold Out" : "Unavailable";
      $('.notify-oos').show();

      $('.was_price', $product).text('');
      $('.savings', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.variant-avility-state', $product).text('Out Of Stock');
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
      $('.shopify-payment-button', $product).hide();
      $('.buynow-checkout-btn', $product).hide();
      $notify_form.hide();
      $notifyFormInputs.empty();
      if (variant && !variant.available) {
        $notify_form.fadeIn();
        $notifyFormInputs.empty();
        $notifyFormInputs.append(notifyFormHTML);
      }
  }
};

var productPage = {
    init: function(){

      var draggable = true;
      var prevNextButtons = $('.js-product-gallery').data('nav');
      var autoplay = $('.js-product-gallery').data('autoplay');

      setTimeout(function(){
        imageFunctions.linkGalleryAndCarousel($('.js-product-page-gallery .js-product-gallery'), $('.js-product-page-gallery .product_gallery_nav'));
      }, 1000);

      if($('.js-full-width-product-images').length){
        imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
      }

      if ($('.js-product-gallery').hasClass('single-image')){
        draggable = false;
        prevNextButtons = false;
      }

      if(is_touch_device() && $('.js-product-gallery').hasClass('popup-enabled--false')) {
        imageFunctions.zoom('.js-product-gallery');
        draggable = false;
      } else {
        imageFunctions.zoom('.js-product-gallery', false);
      }

      var $js_product_gallery = $('.js-product-gallery').flickity({
        "adaptiveHeight": true,
        "wrapAround": "true",
        "cellAlign": "left",
        "draggable": true,
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": true,
        "prevNextButtons": prevNextButtons,
        "autoPlay": autoplay ? 6000 : false,
        "dragThreshold": 10,
        "arrowShape": arrowSize
      });

      
      var js_product_desktop_destroy = true;
      

      if( $('.js-product-gallery').length > 0 ){
        if(js_product_desktop_destroy && $(window).width() > 1023){
          $js_product_gallery.flickity('destroy');
        }
        if(js_product_desktop_destroy){
          $(window).on('resize', function(){
            if($(window).width() <= 1024){
              $js_product_gallery.flickity();
            }else{
              $js_product_gallery.flickity('destroy');
            }
          });
        }
      }

      var groupCells = true;
      var navPrevNextButtons = false;
      var navCellAlign = "center";
      var navWrapAround = false;

      if ($('.product_gallery_nav .gallery-cell').length >= 7) {
        groupCells = false;
        navPrevNextButtons = true;
        navCellAlign = "left";
        navWrapAround = true;
      }

      $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
        "asNavFor": ".product_gallery",
        "adaptiveHeight": false,
        "wrapAround": navWrapAround,
        "cellAlign": "center",
        "draggable": true,
        "groupCells": groupCells,
        "prevNextButtons":  navPrevNextButtons,
        "pageDots": false,
        "lazyLoad": 2,
        "dragThreshold": 10,
        "arrowShape": arrowSize
      });

      $(".js-product_section .product_form_options").each(function() {
        new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: false });
      });

      if (window.location.search === '?contact_posted=true') {
        $('.notify_form .contact-form').hide();
        $('.notify_form .contact-form').prev('.message').html("Thanks! We will notify you when this product becomes available!");
      }

      var $notify_form = $('.notify_form .contact-form');
      $notify_form.each(function() {
        var $nf = $(this);
        $nf.on("submit", function (e) {
          if($('input[name="challenge"]', $nf).val() !== "true") {
            $.ajax({
              type: $nf.attr('method'),
              url: $nf.attr('action'),
              data: $nf.serialize(),
              success: function (data) {
                $nf.fadeOut("slow", function(){
                  $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
                });
              },
              error: function(data) {
                $('input[name="challenge"]', $nf).val('true');
                $nf.submit();
              }
            });
            e.preventDefault();
          }
        });
      });

      
      $('body').on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product_form form');


        if (parentForm.siblings('.notify_form').length){
          var notifyForm = parentForm.siblings('.notify_form');
        } else {
          var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3){
          var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2){
          var notifyMessage = option1 + ' / ' + option2;
        } else {
          var notifyMessage = option1;
        }


        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage );

        $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
      });
      

      $('.js-product-gallery a').fancybox({
        baseClass: "product-section__lightbox",
        clickContent: false,
        afterShow: function(instance, slide) {
          const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
          if (zoom){
            $('.fancybox-image')
            .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
            .css('display', 'block')
            .parent()
            .zoom({
              touch: false,
              magnify: 1
            });
          }
        },
        afterClose: function(instance, slide) {
          const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
          $instanceGallery.hide();
          setTimeout(function(){
            $instanceGallery.fadeIn(100);
          }, 1);
        }
      })

    },
    productSwatches: function(){
          //Swatches linked with selected options
          
          if ($('.js-product_section').length){
            var $productForms = $('.js-product_section').find('.product_form');
            $productForms.addClass('is-visible');

            //Loop through each product and set the initial option value state

            $productForms.each(function(){
              var JSONData = $(this).data('product');
              var productID = $(this).data('product-id');
              var productSection = '.product-' + productID + ' .js-product_section';
              var swatchOptions = $(this).find('.swatch_options .swatch');
              if (swatchOptions.length > 1){
                Shopify.linkOptionSelectors(JSONData, productSection);
              }
            });
          }

          //Add click event when there is more than one product on the page (eg. Collection in Detail)
          if ($('.js-product_section').length > 1){
            $('body').on('click', '.swatch-element', function(){
              var swatchValue = $(this).data('value').toString();

              $(this)
              .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
              .prop("checked", true)
              .trigger("change");

              var JSONData = $(this).parents('.product_form').data('product');
              var productID = $(this).parents('.product_form').data('product-id');
              var productSection = '.product-' + productID + ' .js-product_section';
              var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

              if (swatchOptions.length > 1){
                Shopify.linkOptionSelectors(JSONData, productSection);
              }
            })
          }
          
        },
        relatedProducts: function(){

            $('.js-related-products-slider .products-slider').each(function (index, value) {
              var products_per_slide = $(this).data('products-per-slide');
              var products_limit = $(this).data('products-limit');
              var products_available = $(this).data('products-available');
              var cellAlign,
                  draggable,
                  prevNext,
                  wrapAround,
                  initialIndex;

              if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
                cellAlign = "left";
              } else {
                cellAlign = "center";
              }

              if (products_available > products_per_slide && products_limit > products_per_slide) {
                draggable = true;
                prevNext = true;
                wrapAround = true;
              } else {
                draggable = false;
                prevNext = false;
                wrapAround = false;
              }

              if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
                initialIndex = 0;
              } else if (products_per_slide == "3" && products_available) {
                initialIndex = 1;
              } else if (products_per_slide == "5" && products_available) {
                initialIndex = 2;
              } else if (products_per_slide == "7" && products_available) {
                initialIndex = 3;
              }

              if ($(window).width() <= 798) {
                cellAlign = "center";
                draggable = true;
                prevNext = true;
                wrapAround = true;
                initialIndex = 1;

                $(this).parents('.even-num-slides').removeClass('even-num-slides');
              }

              $(this).flickity({
                "lazyLoad": 2,
                "imagesLoaded": true,
                "draggable": true,
                "cellAlign": 'left',
                "prevNextButtons": true,
                "wrapAround": true,
                "pageDots": false,
                "freeScroll": false
              });
            });
          },
            initializeQuantityBox: function(){

              $('body').on('click', '.js-change-quantity', function() {
                var $this = $(this),
                    $input = $(this).siblings('input'),
                    val = parseInt($input.val()),
                    valMax = 100000000000000000000000000000,
                    valMin = $input.attr('min') || 0;

                if ($input.attr('max') != null){
                  valMax = $input.attr('max');
                }

                if(isNaN(val) || val < valMin) {
                  $input.val(valMin);
                  return false;
                } else if (val > valMax) {
                  $input.val(valMax);
                  return false;
                }

                if($this.data('func') == 'plus') {
                  if(val < valMax) $input.val(val + 1);
                } else {
                  if(val > valMin) $input.val(val - 1);
                  if($this.parents(".cart_item").length) {
                    if (val - 1 == 0) {
                      $this.closest('.cart_item').addClass('animated fadeOutUp')
                    }
                  }
                }
                $input.trigger('change');

              });
            },
        unload: function($target){

         var $slider = $target.find('.products-slider');
         $slider.flickity('destroy');

    }
  }

  /*============================================================================
  Header
==============================================================================*/

  var header = {
    init: function(){

      var closeDropdown = function() {
        $('body').removeClass('is-active');
        $('.dropdown_link').removeClass('active_link');
        $('.dropdown_container').hide();
        $('body').removeClass('megamenu-opened');
        $('.mobile_nav').find('div').removeClass('open');
      };

      var closeMiniCart = function() {
        $('body').removeClass('is-active').removeClass('blocked-scroll');
        $('.dropdown_link').toggleClass('active_link');
        $('.cart_container').removeClass('active_link');
      };

      var openMiniCart = function($cart_container) {
        $('body').addClass('blocked-scroll');
        $('.mobile_nav div').removeClass('open');
        $('.dropdown_link').removeClass('active_link');
        $cart_container.addClass('active_link');
      };

      //Vertical menu enabled
      if ($('.dropdown_link--vertical').length){
        $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
          var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
          var clickCount = $(this).attr('data-click-count');

          $('.active_link').removeClass('active_link');
          if(!$(this).hasClass('active_link')) {
            $(this).children('a').addClass('active_link');
            $('.is-absolute').parent().removeClass('feature_image');
          }
        });

        //Enable touch on parent link if on touch device and desktop menu is visible
        if(is_touch_device()){
          $('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a').on('touchstart click', function(e) {
            e.stopPropagation();

            var verticalMenu = $(this);

            if(e.type == "touchstart") {
              clicked = true;
              if($(this).attr('data-click-count') < 1) {
                openDropdown(verticalMenu);
                e.preventDefault();
              }
            }
            else if(e.type == "click" && !clicked) {
              if($(this).attr('data-click-count') < 1) {
                openDropdown(verticalMenu);
                e.preventDefault();
              }
            }
            else {
              clicked = false;
            }

            function openDropdown(verticalMenu) {

              var $dropdownMegaMenu = $(verticalMenu).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
              var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
              var clickCount = $(verticalMenu).attr('data-click-count');

              $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
              $('.dropdown_link--vertical').attr('data-no-instant', true);
              $('.dropdown_container').hide();
              $('body').removeClass('megamenu-opened');

              $dropdownMegaMenu.show();
              $('.vertical-menu_submenu').removeClass('is-visible');
              $dropdownVertical.addClass('is-visible');

              //capture touch event
              if (e.type == 'touchstart'){
                clickCount++;
                $(verticalMenu).attr('data-click-count', clickCount);

                if (clickCount < 2){
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                }
              }
            }
          });
        }
      }

      if ($('.promo_banner').length){
        var promo_banner = Cookies.get('promo_banner');

        if (promo_banner != 'dismiss') {
          $('body').addClass('promo_banner-show');
          $('.promo_banner').on('click', '.promo_banner-close', function(){
            $('body').removeClass('promo_banner-show');
            Cookies.set('promo_banner', 'dismiss', { expires: 30 });
          });
        }
      }

      //offscreen check for menu
      $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
        if($(this).is(':off-right')) {
          $(this).addClass('vertical-menu--align-right');
        }
      });

      //Click anywhere outside of dropdown to close
      $('html').on('click', function(event) {
        if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {

          closeMiniCart();
        }

        if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {

          closeDropdown();
        }

      });

      //Only apply on larger screen sizes
      // if ($(window).width() > 798) {
      //   if ($('.main_nav_wrapper').hasClass('sticky_nav_enabled')) {
      //     var sticky_nav = new Headhesive('.main_nav_wrapper', {
      //       offset: 190,
      //       throttle: 300,
      //       classes: {
      //         clone: 'sticky_nav',
      //         stick: 'sticky_nav--stick',
      //         unstick: 'sticky_nav--unstick'
      //       },
      //       onInit: function() {
      //         $(".sticky_nav .secondary_logo").css('display', 'none');
      //         $(".sticky_nav .primary_logo").css('display', 'block');
      //         $(".sticky_nav .icon-search").css('display', 'block');
      //         $(".sticky_nav .search_container").css('display', 'none');
      //         $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
      //         
      //         var sticky_nav_height = $(".sticky_nav .nav").height() + 5;
      //         
      //         $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5);
      //         $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height());
      //       },
      //       onUnstick: function() {
      //         $('.cart_container').removeClass('active_link');
      //       }
      //     });
      //   }
      //   var lastScrollTop = 0;
      //   $(window).scroll(function(event){
      //     var st = $(this).scrollTop();
      //     if (st > lastScrollTop){
      //       $('.sticky_nav').css({
      //         opacity: "0",
      //         transition: "opacity 0s"
      //       });
      //     } else {
      //       $('.sticky_nav').css({
      //         opacity: "",
      //         transition: ""
      //       });
      //     }
      //     lastScrollTop = st;
      //   });
      // }

      //avoid cart_content duplicating
      if($('.cart_content').length <= 2) {
        $('#header .cart_container').append($('.cart_content').clone());
      }

      if ( is_touch_device() || $(window).width() <= 798 ) {

        $('.dropdown_link').attr('data-no-instant', true);

        $('body').on('click', '.dropdown_link', function(e) {
          $('.nav a').removeClass('active_link');

          if ($('#header').is(':visible')) {
            var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

            if(!$(this).hasClass('mini_cart')) {
              $('.cart_container').removeClass('active_link');
            }

          } else {

            if($(this).hasClass("icon-search")) {
              window.location = $(this).attr("href");
              return false;
            }

            var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
            }

          if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
            $dropdown.hide();
            $('body').removeClass('megamenu-opened');
            $('body').removeClass('is-active');
          } else {
            $('.dropdown_container').hide();
            $('body').removeClass('megamenu-opened');
            if(!$(this).hasClass('cart_container')) {
              $('.is-absolute').parent().removeClass('feature_image');
            }
            $dropdown.show();
            $('body').addClass('is-active');
            $('.mobile_nav').find('div').removeClass('open');
          }

          if ($dropdown.is(':visible')) {
            e.stopPropagation();
            return false;
          }
        });

        $('body').on("click", '.mobile_nav', function() {
          $(this).find('div').toggleClass('open');
        });

        //Toggle mini-cart with menu icon
        $(".mini_cart").on("click", function(e) {
          var $cart_container = $(this).parent();
          if($cart_container.hasClass('active_link')) {
            closeMiniCart();
            $('body').removeClass('blocked-scroll');
          } else {
            openMiniCart($cart_container);
            $('body').addClass('blocked-scroll');
          }

          if (is_touch_device() || $(window).width() <= 798) {
            e.preventDefault();
          }
        });

        $('.cart_content__continue-shopping').on('click', function(e){
          closeMiniCart();
        })

      } else {

        $(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
          if(!$(this).hasClass("active_link")) {
            $('.dropdown_container').hide();
            $('body').removeClass('megamenu-opened');
            $('.active_link').removeClass('active_link');
            $('.is-absolute').parent().addClass('feature_image');
          }
        });

        $('.top_link').on("mouseenter", function() {
          if(!$(this).hasClass("active_link")) {
            $('.dropdown_container').hide();
            $('body').removeClass('megamenu-opened');
            $('.active_link').removeClass('active_link');
            $('.is-absolute').parent().addClass('feature_image');
          }
        });

        $('.main_nav, .top_bar, .cart_container').on("mouseleave", function() {
          if ( $(window).width() > 798) {
            $('.dropdown_container').hide();
            $('body').removeClass('megamenu-opened');
          }
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
        });

        $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);

        $('.dropdown_link').on('mouseover touchstart', function(e) {
          if ( $(window).width() > 798) {
            $('.dropdown_container').hide();
            $('body').removeClass('megamenu-opened');
          }

          var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
          var clickCount = $(this).attr('data-click-count');

          $('.active_link').removeClass('active_link');

          if(!$(this).hasClass('active_link')) {
            $dropdown.show();
            $('body').addClass('megamenu-opened');

            if($(this).hasClass('mini_cart')) {
              $(this).parent('.cart_container').addClass('active_link');
            } else {
              if ( $(window).width() > 798) {
                $(this).addClass('active_link');
              }
              $('.is-absolute').parent().removeClass('feature_image');
            }
          }

          //Enable touch on parent link if on touch device and desktop menu is visible
          if(is_touch_device()){
            $('.dropdown_link').not(this).attr('data-click-count', 0);
            $('.dropdown_link').attr('data-no-instant', true);


            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(this).attr('data-click-count', clickCount);

              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }

        });

      }

    },
    removeDataAttributes: function(target){
      if($(target).length){
        var i,
            $target = $(target),
            attrName,
            dataAttrsToDelete = [],
            dataAttrs = $target.get(0).attributes,
            dataAttrsLen = dataAttrs.length;

        for (i=0; i<dataAttrsLen; i++) {
          if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
            dataAttrsToDelete.push(dataAttrs[i].name);
          }
        }
        $.each( dataAttrsToDelete, function( index, attrName ) {
          $target.removeAttr( attrName );
        })
      }
    },
    loadMegaMenu: function(){

      //Remove old mega-menus so that theme-editor works properly
      $('.sticky_nav .mega-menu').remove();
      $('.header .mega-menu').remove();

      //Clone the mega menu from section into sticky_nav
      $('.mega-menu-container .mega-menu')
      .clone()
      .appendTo('.sticky_nav .main_nav');
      //Remove theme-editor data-attributes
      header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

      //Loop through mega-menus to add arrow to parent
      $('.mega-menu-container .mega-menu').each(function(index){
        var megaMenuValue = $(this).data("dropdown");
        $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

        $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link')
        .removeClass('top_link');

        $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
          if (!$(this).hasClass('mega-menu')) {
            $(this).remove();
          }
        });

        $(this).clone().appendTo('.header .main_nav');
      });

      //Remove default mega menus if vertical menus are selected
      if ($('.dropdown_link--vertical').length){
        $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
        $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
          var megaMenuValue = $(this).data('dropdown-rel');
          $('[data-dropdown="' + megaMenuValue + '"]').remove();
        })
      }

      $('.mega-menu-parent').on('mouseenter', function() {

        if(!$(this).hasClass('active_link')) {
          $('.dropdown_container').hide();
          $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

          $(this).addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');

        }
      });

      //Remove theme-editor data-attributes
      header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

      if (is_touch_device() || $(window).width() <= 798) {
        $('.dropdown_link').attr('data-no-instant', true);
      }

      header.loadMobileMegaMenu();
    },
    loadMobileMegaMenu: function() {

      //Loop through mega menus and add to mobile menu
      $('.mega-menu-container .mobile-mega-menu').each(function(index){
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
        $('.mhs-nav-wrap').append(this);
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
          if (!$(this).hasClass('mobile-mega-menu')) {
            $(this).remove();
          }
        });
      });
    },
    unloadMegaMenu: function(){
      $('.header .mega-menu').remove();
      $('.mega-menu-container .mega-menu').each(function(index){
        var menuParent = $(this).data('dropdown');
        $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
      });
    },
    unload: function() {
      $('body').off('click', '.mobile_nav');
      $('body').off('click', '.dropdown_link');
      $('html').off('click');
      $('.mini_cart').off('click');
      $('.cart_content__continue-shopping').off('click');
      $('body').off('click', '.banner a[href^="#"]');
    }
  }

  /*============================================================================
  Social media
==============================================================================*/

  var social = {
    twitter: function(){
      if (!window.twttr){
        //Initialize twitter feed
        window.twttr = (function (d,s,id) {
          var t, js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
          js.src="https://platform.twitter.com/widgets.js";
          fjs.parentNode.insertBefore(js, fjs);
          return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
        }(document, "script", "twitter-wjs"));
      }

      if (window.twttr) {
        window.twttr.ready(function (twttr) {
          twttr.widgets.load(
            document.getElementById("twitter-timeline")
          );
        });
      }
    },
    unload: function(){

    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                var url = thisMedia.images.low_resolution.url;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
                }

                if(item) {
                  item = '<div class="'+s.column+ ' columns instagram__item small-down--one-whole">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count'),
      column: $target.data('column')
    });
  });

/*============================================================================
  Map
==============================================================================*/
  var mapFunction = {
    init: function() {

      if($('.lazymap').length > 0){
        lazyframe('.lazymap');
      }

      if ($('.maps').hasClass('js-api-map')) {
        var mapsToLoad = [];
        //Create map settings array
        $('.map').each(function(i, obj) {
          mapsToLoad.push(this);
          mapsToLoad[i].sectionid = $(this).data('id');
          mapsToLoad[i].address = $(this).data('address');
          mapsToLoad[i].directions = $(this).data('directions-address');
          mapsToLoad[i].zoom = $(this).data('zoom');
          mapsToLoad[i].mapstyle = $(this).data('style');
          mapsToLoad[i].showpin = $(this).data('pin');
          mapsToLoad[i].apikey = $(this).data('api-key');
        });
        $.each(mapsToLoad, function(i, instance) {
          //Enable caching to avoid duplicate google maps files
          $.ajaxSetup({ cache: true });
          //Load maps script and find location coordinates
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey
          ).then(function() {
            mapFunction.findLocation(mapsToLoad[i]);
            $.ajaxSetup({ cache: false });
          });
        });
      }
    },
    findLocation: function(mapArray) {
      var geoLat;
      var geoLng;
      var geocoder = new google.maps.Geocoder();
      //Find and set coordinates
      geocoder.geocode({ address: mapArray.address }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          geoLat = results[0].geometry.location.lat();
          geoLng = results[0].geometry.location.lng();
          //Create map
          mapFunction.initMap(geoLat, geoLng, mapArray);
        } else {
          console.log('Error:' + status);
        }
      });
    },
    initMap: function(lat, lng, mapArray) {
      var location = { lat: lat, lng: lng };
      var styleJson = [];
      //Set style JSON
      if(mapArray.mapstyle=='aubergine'){
        styleJson=[{elementType:'geometry',stylers:[{color:'#1d2c4d'}]},{elementType:'labels.text.fill',stylers:[{color:'#8ec3b9'}]},{elementType:'labels.text.stroke',stylers:[{color:'#1a3646'}]},{featureType:'administrative.country',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#64779e'}]},{featureType:'administrative.province',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'landscape.man_made',elementType:'geometry.stroke',stylers:[{color:'#334e87'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#023e58'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#283d6a'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#6f9ba5'}]},{featureType:'poi',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#023e58'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#3C7680'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#304a7d'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'road',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#2c6675'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#255763'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#b0d5ce'}]},{featureType:'road.highway',elementType:'labels.text.stroke',stylers:[{color:'#023e58'}]},{featureType:'transit',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'transit',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'transit.line',elementType:'geometry.fill',stylers:[{color:'#283d6a'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#3a4762'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0e1626'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#4e6d70'}]}]
      }else if(mapArray.mapstyle=='retro'){
        styleJson=[{elementType:'geometry',stylers:[{color:'#ebe3cd'}]},{elementType:'labels.text.fill',stylers:[{color:'#523735'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f1e6'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#c9b2a6'}]},{featureType:'administrative.land_parcel',elementType:'geometry.stroke',stylers:[{color:'#dcd2be'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#ae9e90'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#93817c'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#a5b076'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#447530'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#f5f1e6'}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#fdfcf8'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#f8c967'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#e9bc62'}]},{featureType:'road.highway.controlled_access',elementType:'geometry',stylers:[{color:'#e98d58'}]},{featureType:'road.highway.controlled_access',elementType:'geometry.stroke',stylers:[{color:'#db8555'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#806b63'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'transit.line',elementType:'labels.text.fill',stylers:[{color:'#8f7d77'}]},{featureType:'transit.line',elementType:'labels.text.stroke',stylers:[{color:'#ebe3cd'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'water',elementType:'geometry.fill',stylers:[{color:'#b9d3c2'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#92998d'}]}]
      }else if(mapArray.mapstyle=='silver'){
        styleJson=[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]
      }else if(mapArray.mapstyle=='night'){
        styleJson=[{elementType:'geometry',stylers:[{color:'#242f3e'}]},{elementType:'labels.text.fill',stylers:[{color:'#746855'}]},{elementType:'labels.text.stroke',stylers:[{color:'#242f3e'}]},{featureType:'administrative.locality',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#263c3f'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#6b9a76'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#38414e'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#212a37'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#9ca5b3'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#746855'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#1f2835'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#f3d19c'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#2f3948'}]},{featureType:'transit.station',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#17263c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#515c6d'}]},{featureType:'water',elementType:'labels.text.stroke',stylers:[{color:'#17263c'}]}]}else{styleJson=[]}
      //Create google maps link
      $('.js-map-link').attr(
        'href',
        'https://www.google.com/maps/place/' +
        mapArray.directions +
        '/@' +
        lat +
        ',' +
        lng
      );
      //Set map options
      var mapOptions = {
        zoom: mapArray.zoom,
        center: location,
        styles: styleJson,
        disableDefaultUI: false
      };
      //Create map
      var map = new google.maps.Map(
        document.getElementById(mapArray.sectionid),
        mapOptions
      );
      //Show pin
      if (mapArray.showpin == true) {
        var marker = new google.maps.Marker({
          position: location,
          map: map
        });
      }
    }
  };

/*============================================================================
  FAQ
==============================================================================*/
  var faqAccordion = {
    init: function(){
      var flg = 0;
      var $faqHeading = $('.faqAccordion > dt > button');
      $('.faqAccordion > dd').attr('aria-hidden',true);
      $faqHeading.attr('aria-expanded',false);
      $faqHeading.on('click activate',function(){
        if( flg ) return false;
        flg = 1;
        var state = $(this).attr('aria-expanded') === 'false' ? true : false;
        $(this).attr('aria-expanded',state);
        $(this).parent().next().slideToggle(function(){
          flg = 0;
        });
        $(this).parent().next().attr('aria-hidden',!state);
        return false;
      });
      $faqHeading.on('keydown',function(event){
        var keyCode = event.keyCode || e.which;
        if (keyCode === 13){
          $(this).trigger('activate');
        }
      });
    }
  }



  /* ==================================================
#Image functions
#Recently viewed
#Load more / infinite load
#Filter products with AJAX
#Search autocomplete
#Sidebar filter on collection pages
#Misc
#Quick shop
#Newsletter popup

/*============================================================================
  Image functions
==============================================================================*/

  var imageFunctions = {
    zoom: function(zoomParent, enableTouch, magnify){
      var activateZoom = $(zoomParent).data('zoom');
      if (activateZoom){
        $(zoomParent + ' img')
        .wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          touch: enableTouch,
          magnify: magnify ? magnify : 1
        });
      }
    },
    linkGalleryAndCarousel: function($gallery, $carousel){

      $carousel.find('.gallery-cell:nth-child(1)').addClass('is-nav-selected');

      //EVENT - click on carousel item to slide gallery
      $carousel.on( 'click', '.gallery-cell', function() {
        var index = $(this).index();
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $(this).addClass('is-nav-selected');
        $gallery.flickity( 'select', index );
      });

      //EVENT - update carousel based on gallery index
      $gallery.on( 'select.flickity', function() {
        var galleryData = $(this).data('flickity');
        if (galleryData){
          $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
          $carousel.find('.gallery-cell:nth-child(' + (galleryData.selectedIndex + 1) + ')').addClass('is-nav-selected');
        }
      });
    },
    fullWidth: function(images, imageContainer){
      $(images).each(function(){
        var $image = $(this),
            alt = $image.attr('alt'),
            src = $image.attr('src');

        if (alt.indexOf("[") >= 0){

          //remove from description
          $image.remove();

          //find shortcode values and remove from alt
          var shortcodes = alt.match(/\[(.*?)\]/ig);
          alt = alt.replace(/\[(.*?)\]/ig, '');

          //remove brackets from shortcode to be used as classes
          var captionClass = $.map( shortcodes, function( value, index ) {
            value = value.replace(/[\[\]']+/g,'');
            return value;
          });

          //markup for caption

          var caption = [
            '<div class="position-' + (captionClass.length ? captionClass : 'center') + ' caption js-caption">',
            '<div class="caption-content caption-background-false align-' + (captionClass.length ? captionClass : 'center') + '">',
            '<p class="headline">' + alt + '</p>',
            '</div>',
            '</div>'
          ].join('');

          //image attributes added
          $image.attr({
            alt: alt,
            class: 'lazyload blur-up',
            src: src,
            dataSizes: 'auto'
          });

          var image = $image.prop('outerHTML')
          var banner =  '<div class="banner">' + image + caption + '</div>'

          $(imageContainer).append(banner);
        }
      })
    },
    showSecondaryImage: function(){
      if ($(window).width() > 798) {
        $('body').on("mouseenter", ".swap-true", function() {
          $(this).toggleClass('toggle-images');
        });

        $('body').on("mouseleave", ".swap-true", function() {
          $(this).toggleClass('toggle-images');
        });
      }
    }
  }

/*============================================================================
  Recently viewed
==============================================================================*/

  var recentlyViewed = {
    init: function(){

      var productHandle,
          rvCookie,
          rvProducts,
          displayProducts,
          rvProductArray;

      if ($('.js-product_section[data-rv-handle]').length){
        productHandle = $('.js-product_section').data('rv-handle').toString();
        rvCookie = Cookies.get('recentlyViewed');
        rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
      } else if ($('.recently-viewed__section').length){
        rvCookie = Cookies.get('recentlyViewed');
        rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
      } else if ($('.js-sidebar-recently-viewed').length){
        rvCookie = Cookies.get('recentlyViewed');
        rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
      }

      if (rvProducts){
        rvProductArray = unescape(rvProducts).split(',');
      }

      if (productHandle){

        if(!$.inArray(productHandle, rvProductArray) !== -1){
          displayProducts = [];
          rvProductArray.unshift(productHandle);
          $.each(rvProductArray, function(i, el){
            if($.inArray(el, displayProducts) === -1) displayProducts.push(el);
          });
        }

        recentlyViewed.setCookieProducts(displayProducts);
      } else {
        displayProducts = rvProductArray;
      }

      if ($('.recently-viewed__section').length){
        var parent = '.recently-viewed__section';
        recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else if ($('.js-recently-viewed .rv-main').length){
        var parent = '.js-recently-viewed';
        recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      }

      if ($('.sidebar .js-sidebar-recently-viewed').length){
        var parent = '.sidebar .js-sidebar-recently-viewed';
        if (productHandle){
          recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
        } else {
          recentlyViewed.getProductInformation(parent, displayProducts);
        }
        $('.js-sidebar-recently-viewed.hidden').parents('.sidebar-block').hide();
      }

    },
    getCookieProducts: function(rvCookie, productHandle){

      if (!rvCookie && productHandle) {
        Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
        rvCookie = Cookies.get('recentlyViewed');
      } else {
        rvCookie = Cookies.get('recentlyViewed');
      }

      return rvCookie;

    },
    setCookieProducts: function(rvProductArray){
      Cookies.set('recentlyViewed', escape(rvProductArray.join(',')), { expires: 30, path: '/' });
    },
    getProductInformation: function(parent, displayProducts, productHandle){

      if (productHandle){
        displayProducts.splice( $.inArray(productHandle, displayProducts), 1 );
      }

      var productLimit = $(parent).data('visible-products');

      if (productLimit && displayProducts){
        displayProducts = displayProducts.slice(0, productLimit);
      }

      $.each(displayProducts, function (index, value) {

        if (value){
          $(parent).removeClass('hidden');

          $(parent).parents('.sidebar-block').show();

          $.ajax({
            type: 'GET',
            url: '/products/' + value  + '?view=rv',
            success: function(data) {

              var rvProduct = $(data).find('.js-recently-viewed-product');

              $(parent).find(' .rv-box-' + index ).append(rvProduct);

            },
            error: function(x, t, m) {
              console.log(x);
              console.log(t);
              console.log(m);
            },
            dataType: "html"
          });
        }

        if ($(parent).find('.rv-main').hasClass('js-rv-slider')){
          if (displayProducts.length <= productLimit) {
            $('.js-rv-slider .gallery-cell').eq(displayProducts.length).nextAll().addBack().remove();
          } else {
            $('.js-rv-slider .gallery-cell').eq(productLimit).nextAll().addBack().remove();
          }
          recentlyViewed.createSlider(parent, productLimit);
        } else if ($(parent).find('.rv-main').hasClass('js-rv-grid')){
          if (displayProducts.length <= productLimit) {
            $('.js-rv-grid .thumbnail').eq(displayProducts.length).nextAll().addBack().remove();
          } else {
            $('.js-rv-grid .thumbnail').eq(productLimit).nextAll().addBack().remove();
          }
        }
      });
    },

    createSlider: function(el, productsAvailable){

      var products_per_slide = $('.js-rv-slider').data('products-per-slide');
      var products_limit = $('.js-rv-slider').data('products-limit');
      var products_available = productsAvailable;
      var indexProductsAvailable = productsAvailable - 1;
      var rvProductstoShow = $('.js-rv-slider').find('.gallery-cell');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {

        cellAlign = "center";
        initialIndex = 1;

        if (rvProductstoShow.length <= 2){
          draggable = false;
          prevNext = false;
          wrapAround = false;
        } else if (products_available > 3 && products_limit > 3) {
          draggable = true;
          prevNext = true;
          wrapAround = true;
        } else {
          draggable = false;
          prevNext = false;
          wrapAround = false;
        }

        $('.js-rv-slider').parents('.even-num-slides').removeClass('even-num-slides');
      }

      $('.js-rv-slider').flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": false,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $('.js-rv-slider').addClass('slider-initialized');
    }
  }

  /* ===============================================
  #Load more / infinite load
================================================== */

  //Collection template

  var enableLoadMoreProducts = function(){
    $('body').on('click', '.js-load-more a', function(e){
      enableInfiniteScroll();
      e.stopPropagation();
      return false;
    });
  }

  var enableInfiniteScroll = function(){
    if ($('.collection-matrix').length) {
      var infiniteScroll = new Waypoint.Infinite({
        element: $('.collection-matrix')[0],
        items: '.collection-matrix',
        more: '.load-more__btn',
        loadingClass: 'loading-in-progress',
        onBeforePageLoad: function(){
          $('.js-load-more').hide();
        },
        onAfterPageLoad: function(data){
          $('.collection-matrix > .collection-matrix .thumbnail').unwrap('.collection-matrix');
          
        }
      })
      }
  }

  //Search template

  var enableLoadMoreSearch = function(){
    $('body').on('click', '.js-load-more a', function(e){
      enableInfiniteSearchScroll();
      e.stopPropagation();
      return false;
    });
  }

  var enableInfiniteSearchScroll = function(){
    if ($('.search-matrix').length) {
      var infiniteSearchScroll = new Waypoint.Infinite({
        element: $('.search-matrix')[0],
        items: '.search-matrix',
        more: '.load-more__btn',
        loadingClass: 'loading-in-progress',
        onBeforePageLoad: function(){
          $('.js-load-more').hide();
        },
        onAfterPageLoad: function(data){
          $('.search-matrix > .search-matrix .thumbnail').unwrap('.search-matrix');
          
        }
      })
      }
  }

  /*============================================================================
  Filter Products with AJAX
==============================================================================*/

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var quickFilter = {
    init: function(){
      var selectedOptions = [],
          query = '',
          currentTags = '',
          siteUrl = 'https://' + $.url('hostname'),
          url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
          url2 = $.url('2') ? $.url('2') + '/' : '',
          url3 = $.url('3'),
          path = url1 + url2;

      //Handle dropdowns if they exist
      if ($('#sort-by').length){
        query = $('#sort-by').val();
      } else {
        query = url('?sort_by');
      }

      if ($('#tag_filter').length){

        if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
          urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

          if (urlTag != 'all'){
            if ($.inArray( urlTag, selectedOptions ) > -1){
              //Do nothing
            } else {
              selectedOptions.unshift(urlTag);
            }
          }
        }
      }

      //Add all checkbox values to array
      $('[data-option-filter] input:checked').each(function (){
        selectedOptions.push($(this).val());
      });
      selectedOptions = $.makeArray(selectedOptions);

      //Loop through tags to create string to update page url
      $.each(selectedOptions, function(i, value){

        if (i != selectedOptions.length - 1) {
          currentTags += selectedOptions[i] + '+';
        } else {
          currentTags += selectedOptions[i];
        }

      });

      Shopify.queryParams.sort_by = query;
      query = '?' + $.param(Shopify.queryParams);

      quickFilter.processUrl(path, currentTags, query);
    },
    updateView: function(filterURL) {

      $.ajax({
        type: 'GET',
        url: filterURL,
        beforeSend: function() {
          $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
          Waypoint.destroyAll()
        },
        success: function(data) {
          $(".collection-matrix").removeClass('loading-in-progress');
          $(".collection-matrix").removeClass('filter-loading');
          var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
          $('.breadcrumb_text').html(filteredBreadcrumb);

          var filteredPagination = $(data).find('.paginate').html();
          $('.paginate').html(filteredPagination);

          var filteredSidebar = $(data).find('.sidebar').html();
          $('.sidebar').html(filteredSidebar);

          var filteredPageLinks = $(data).find('.paginate').html();
          $('.paginate').empty();
          $('.paginate').html(filteredPageLinks);

          var filteredData = $(data).find('.collection-matrix');
          $('.collection-matrix').remove();
          filteredData.insertBefore( $('.load-more__icon') );

          window.history && window.history.pushState && window.history.pushState("", "", filterURL);

          if ($('.sidebar__collection-filter').length){
            collectionSidebarFilter.init();
          }

          

          
        },
        error: function(x, t, m) {
          console.log(x);
          console.log(t);
          console.log(m);
          location.replace(location.protocol + '//' + location.host + filterURL);

        },
        dataType: "html"
      });
    },
    processUrl: function(path, tags, query){

      var query = query.replace(/\page=(\w+)&/, ''),
          urlString = '';

      urlString = path + tags + query;

      quickFilter.updateView(urlString);

    }
  }

  var collectionquickFilter = {
    init: function(col_val){
      var selectedOptions = [],
          query = '',
          currentTags = '',
          siteUrl = 'https://' + $.url('hostname'),
          url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
          url2 = $.url('2') ? $.url('2') + '/' : '',
          url3 = $.url('3'),
          path = url1 + url2;
      
      //Handle dropdowns if they exist
      if ($('body').data('default-sort') != ''){
        query = $('body').data('default-sort');
      } else {
        query = url('?sort_by');
      }

      //Add all checkbox values to array
      $('[data-option-filter] input:checked').each(function (){
        selectedOptions.push($(this).val());
      });
      selectedOptions = $.makeArray(selectedOptions);

      //Loop through tags to create string to update page url
      $.each(selectedOptions, function(i, value){

        if (i != selectedOptions.length - 1) {
          currentTags += selectedOptions[i] + '+';
        } else {
          currentTags += selectedOptions[i];
        }

      });
      
      Shopify.queryParams.sort_by = query;
      query = '?' + $.param(Shopify.queryParams);

      collectionquickFilter.processUrl(path, currentTags, col_val, query);
    },
    updateView: function(filterURL, col_val) {

      $.ajax({
        type: 'GET',
        url: filterURL,
        beforeSend: function() {
          $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
          $('body').removeClass('one-column-view two-column-view three-column-view four-column-view');
          Waypoint.destroyAll()
        },
        success: function(data) {
          var type_filter = false;

          var filteredPageLinks = $(data).find('.paginate').html();
          $('.paginate').empty();
          $('.paginate').html(filteredPageLinks);
          
          var filterPagenation = $(data).find('.js-load-more');
          
          $('.collection-matrix').remove();
          var filteredData = $('<div class="product-list collection-matrix"></div>');

          $('.toggle_type-list li').each(function(i,data){
            if($(this).find('input').prop('checked')){
              type_filter = true;
            }
          });

          var side_query = $('.side_query').val();


          $.each($(data).find('.thumbnail'), function(){
            var type = $(this).data('type');
            var thumbnail = $(this);
            var title = $(this).find('.title').text();console.log(thumbnail);
            if(type_filter && (side_query.length >= 3)){

              $('.toggle_type-list li').each(function(i,data){
                if($(this).find('input').prop('checked')){
                  var v = $(this).find('input').val();
                  if(v == type){
                    if(title.includes(side_query)){
                      filteredData.append(thumbnail);
                    }
                  }
                }
              });

            }else if(side_query.length >= 3){

              if(title.includes(side_query)){
                filteredData.append(thumbnail);
              }

            }else if(type_filter){

              $('.toggle_type-list li').each(function(i,data){
                if($(this).find('input').prop('checked')){
                  var v = $(this).find('input').val();
                  if(v == type){
                    filteredData.append(thumbnail);
                  }
                }
              });

            }else{
              filteredData.append(thumbnail);
            }
          });
          
          filteredData.append(filterPagenation);

          filteredData.insertBefore( $('.load-more__icon') );
          
          if($('.thumbnail').length == 0){
            if($('.collection-matrix p.quote').length == 0){
              filteredData.append("<p>No products found in this collection.</p>");
            }
          }         

          $('body').addClass(col_val);

          window.history && window.history.pushState && window.history.pushState("", "", filterURL);

          

          
        },
        error: function(x, t, m) {
          console.log(x);
          console.log(t);
          console.log(m);
          location.replace(location.protocol + '//' + location.host + filterURL);

        },
        dataType: "html"
      });
    },
    processUrl: function(path, tags, col_val, query){

      var urlString = '';

      urlString = path + tags + query;

      collectionquickFilter.updateView(urlString, col_val);

    }
  }

/*============================================================================
  Search autocomplete
==============================================================================*/

  var searchAutocomplete = {
    init: function(){

      var currentAjaxRequest = null;
      var shopURL = $('body').data('shop-url');

      
      var searchPath = shopURL + '/search?type=product&q=';
      

      //Submit wildcard searches
      $(".search_form, .search__form, .header_search_form").on("submit", function(e){
        var formValue = $(this).find('input[name="q"]').val();
        var cleanFormValue = encodeURI(formValue);

        e.preventDefault();

        if(cleanFormValue == null) {
          window.location.href = '/search';
        } else {
          window.location.href = searchPath + cleanFormValue + '*';
        }
      });

      var searchForms = $('form.search_form, form.search, form.header_search_form').each(function() {

        var input = $(this).find('input[name="q"]');

        // Adding a list for showing search results.
        $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($(this));
        // Listening to keyup and change on the text field within these search forms.
        input.attr('autocomplete', 'off').bind('keyup change', function() {

          if(input.val() == '') {
            $('.search__results').hide();
            $('.search__results').empty();
          }

          var term = $(this).val();
          var cleanTerm = encodeURI(term);

          var form = $(this).closest('form');
          var searchURL =  searchPath + cleanTerm;

          var resultsList = form.find('.search__results');

          if (term.length >= 3) {

            if (currentAjaxRequest != null) currentAjaxRequest.abort();

            currentAjaxRequest = $.getJSON(searchURL +'*&view=json', function(data) {
              resultsList.empty();

              // If we have no results.
              if(data.results_count == 0) {
                resultsList.hide();
              } else {
                // If we have results.
                $.each(data.results, function(index, item) {
                  if(index >= 5) {
                     return false;
                     }

                     var link = $('<a></a>').attr('href', item.url);

                  //Collect collection handles if product
                  if(item.object_type == 'product') {

                    var collectionHandles = [];
                    for(i=0; i < item.collections.length; i++) {
                      collectionHandles.push(item.collections[i].handle);
                    }

                    if($.inArray('coming-soon', collectionHandles) != -1) {
                      var itemPrice = "Coming Soon";
                      } else {
                        if(item.available == true) {

                          if(item.raw_compare > item.raw_price ) {
                            var itemPrice = '<span class="was_price">' + item.compare + '</span> ' + item.price;
                          } else {
                            if(item.price_varies && item.price_min > 0) {
                              var itemPrice = "from" + ' ' + item.price;
                            } else if(item.price > 0 || item.raw_price > 0) {
                              var itemPrice = item.price;
                            } else {
                              var itemPrice = 'Free';
                            }
                          }
                        } else {
                          var itemPrice = "Sold Out";
                          }
                      }

                    if(item.thumbnail != 'NULL') {
                      link.append('<div class="thumbnail"><img class="lazyload blur-up" src="' + item.thumbnail + '" /></div>');
                                  }
                                  link.append('<div class="title">' + item.title + '<br><span class="item-pricing">'+ itemPrice +'</span></div>');


                    } else if(item.object_type == 'article') {
                      if(item.thumbnail != 'NULL') {
                        link.append('<div class="thumbnail"><img class="lazyload blur-up" src="' + item.thumbnail + '" /></div>');
                                    }
                                    link.append('<div class="title">' + item.title + '<br><span class="item-pricing">'+ item.text_content +'</span></div>');

                      } else if(item.object_type == 'page') {
                        link.append('<div class="title">' + item.title + '<br><span class="item-pricing">'+ item.text_content +'</span></div>');
                      }

                      link.wrap('<li class="item-result result--' + item.object_type + '"></li>');
                      resultsList.append(link.parent());
                    });
                    // The Ajax request will return at the most 5 results.
                    // If there are more than 5, let's link to the search results page.
                    if(data.results_count >= 5) {
                       resultsList.append('<li class="all-results"><span class="title see-all"><a href="' + searchURL + '*">' + "View all results" + ' (' + data.results_count + ')</a></span></li>');
                  }
                  resultsList.fadeIn(200);
                }
                       })
              }
            });
          });

          // Clicking outside makes the results disappear.
          $(document).on('click', function(e){
            var container = $('[data-autocomplete-true]');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              $('[data-autocomplete-true]').find('.search__results-wrapper').hide();
            }
          });

          $('[data-autocomplete-true] input').on('focus', function(){
            $('.search__results-wrapper').hide();
            $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
          });
        },
        unload: function() {
          $('body').off('focus', '[data-autocomplete-true] input');
        }
      }

/*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

var collectionSidebarFilter = {
      init: function() {
        // Hide filters if 'types' or 'vendors' is in the third segment of the URL
        var currentPath = window.location.pathname.split('/');
        var segment = currentPath[2]; // This gives you the third part of the URL
        if (segment === 'types' || segment === 'vendors') {
          var sidebarFilter = document.querySelector('.sidebar__collection-filter');
          if (sidebarFilter) {
            sidebarFilter.remove();
          }
        }
    
        // Remove bottom border if the previous element is empty
        var emptySidebarBlocks = document.querySelectorAll('.sidebar-block:empty');
        emptySidebarBlocks.forEach(function(block) {
          var previousElement = block.previousElementSibling;
          if (previousElement) {
            previousElement.style.borderBottom = 'none';
          }
        });
      },
      
      clearAllFilters: function() {
        var inputs = document.querySelectorAll('[data-option-filter] input');
        inputs.forEach(function(input) {
          input.checked = false;
          input.dispatchEvent(new Event('change'));
        });
      },
      
      clearSelectedFilter: function(optionFilter) {
        var inputs = optionFilter.querySelectorAll('[data-option-filter] input');
        inputs.forEach(function(input) {
          input.checked = false;
          input.dispatchEvent(new Event('change'));
        });
      }
    }



    /*============================================================================
  Misc
==============================================================================*/

    
  var arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
  var svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>'
  var svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
  

  var utils = {
    createAccordion: function(container, tab, content){
      var $container = $(container);
      var $tab = $(container).find(tab);
      var $content = $(container).find(content);
      var specificTab = container + ' ' + tab;

      //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
      if (container.indexOf(".accordion-tabs") >= 0){
        var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
        $container.empty();

        $.each(rearrangedTabs, function (index, value) {
          $container.append(this);
        });

        $content.removeClass('active');
        $container.find('.active').next().slideToggle();

        tab = container + '> a';
      }

      $(container).children('a').each(function(i, tab) {
        var tab = $(this);
        var tabValue = tab.attr('href'); //get tab id
        tab.attr('data-tab-value', tabValue); //set tab id in data attribute
        tab.removeAttr("href"); //remove href (to prevent url hash update)
      });

      $(container).find(tab + '.active').next().slideToggle();
      $('body').on('click', specificTab, function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next().slideToggle();
      });
    },
    mobileAccordion: function(container, tab, content){
      $container = $(container);
      $tab = $(container).find(tab);
      $content = $(container).find(content);

      $(tab + '.active').next().slideToggle();

      $('body').on('click', tab, function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next().slideToggle();
      });
    },
    mobileParentActiveAccordion: function(container, tab, content){
      $container = $(container);
      $tab = $(container).find(tab);
      $content = $(container).find(content);

      $(tab + '.active').parent().next().slideToggle();

      $('body').on('click', tab, function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).parent().next().slideToggle();
      });
    },
    initializeTabs: function(){
      $('ul.tabs > li > a').attr('data-no-instant', true);
      $('body').on('click', 'ul.tabs > li > a', function(e) {
        e.preventDefault();
        var contentLocation = $(this).attr('href');
        if(contentLocation.charAt(0)=="#") {
          $('ul.tabs > li > a.active').removeClass('active');
          $(this).addClass('active');
          $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
        }
      });
    },
    pageBannerCheck: function(){
      //check for header banner
      if (!$('.page_banner').length > 0 || $('.header').hasClass('header-background--solid')) {
        $('.feature_image').removeClass('feature_image');
        $('.header.is-absolute').removeClass('is-absolute');
        //hide secondary logo
        $('.secondary_logo--true').find('.secondary_logo').css('display', 'none');
        $('.secondary_logo--true').find('.primary_logo').css('display', 'block');
      } else {
        $('.header').parent().addClass('feature_image');
        $('.header').addClass('is-absolute');
        //check for secondary logo
        if ($('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').css('display', 'block');
          $('.secondary_logo--true').find('.primary_logo').css('display', 'none');
        }
      }

      //check for section that uses header banner on home page
      if ($('.index-sections').children().first('.under-menu').find('.full-width--true').length) {
        if (!$('.header').hasClass('header-background--solid')) {
          $('.index .header').parent().addClass('feature_image');
          $('.index .header').addClass('is-absolute');
        }
        //check for secondary logo
        if ($('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').show();
          $('.secondary_logo--true').find('.primary_logo').hide();
        }
      } else {
        $('.index .feature_image').removeClass('feature_image');
        $('.index .header.is-absolute').removeClass('is-absolute');
        //hide secondary logo
        if (!$('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').hide();
          $('.secondary_logo--true').find('.primary_logo').show();
        }
      }

      //check for section that uses header banner on the page details template
      if ($('.detail-sections').children().first().hasClass('under-menu')) {
        if (!$('.header').hasClass('header-background--solid')) {
          $('[class^="page-details"] .header').parent().addClass('feature_image');
          $('[class^="page-details"] .header').addClass('is-absolute');
        }

        //check for secondary logo
        if ($('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').show();
          $('.secondary_logo--true').find('.primary_logo').hide();
        }
      } else {
        $('[class^="page-details"] .feature_image').removeClass('feature_image');
        $('[class^="page-details"] .header.is-absolute').removeClass('is-absolute');

        //hide secondary logo
        if (!$('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').hide();
          $('.secondary_logo--true').find('.primary_logo').show();
        }
      }
    },
    resizeActionButtons: function(){
      $('.js-caption:visible').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
            buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });
    }
  }

  var sliderBlock = {
    select: function(blockId, $parentSection){
      var $blocks = $parentSection.find('.gallery-cell');
      var blockIdsArray = $blocks.map(function() {
        return String($(this).data('block-id'));
      });

      var $slider = $parentSection.find('[data-slider-id]');
      var settings = {
        slideshowTextAnimation: $slider.data('slideshow-text-animation')
      }
      var flkty = $slider.data('flickity');

      $slider.flickity('pausePlayer');

      for(var i = 0; i < blockIdsArray.length; i++){
        if(blockIdsArray[i] === blockId){
          var currentSlide = i;
          if (currentSlide !== flkty.selectedIndex){
            $slider.flickity( 'select', parseInt(currentSlide), false, true);
          }
        }
      }
    },
    deselect: function($parentSection){
      var $slider = $parentSection.find('.flexslider').data('flexslider');
      if($slider) {
        $slider.flickity('unpausePlayer');
      }
    }
  }

  /*============================================================================
  Quick shop
==============================================================================*/

  var globalQuickShopProduct;

  var quickShop = {
    init: function(){

      //EVENT - click on quick-shop
      $('body').on('click', '.js-quick-shop-link', function(e){
        e.preventDefault();

        //Set productData object based on data attributes
        const productData = {
          handle: $(this).data('handle'),
          product_id: $(this).data('id'),
          single_variant: $(this).attr('data-single-variant'),
          product_in_collection_url: $(this).data('url'),
          escaped_title: $(this).data('title'),
          details_text: $(this).data('details-text'),
          full_description: $(this).data('full-description'),
          regular_description: $(this).data('regular-description'),
          image_array: quickShop.createImageObjects($(this).data('images')),
          collection_handles: $(this).data('collection-handles').trim(',').split(','),
          money_format: $('body').data('money-format')
        }

        //Find current product and notify forms
        const $notifyForm = $(this).next('.js-quickshop-forms__container').find('.notify_form');
        const $productForm = $(this).next('.js-quickshop-forms__container').find('.product_form');

        $.fancybox.open($('.js-quick-shop'), {
          baseClass: 'quick-shop__lightbox product-' + productData.product_id,
          hash: false,
          infobar : false,
          toolbar: false,
          loop: true,
          smallBtn : true,
          mobile: {
            preventCaptionOverlap: false,
            toolbar: true,
            buttons: [
              "close"
            ]
          },
          beforeLoad: function(){
            quickShop.beforeOpen(productData);
          },
          afterLoad: function(){
            quickShop.afterContent($productForm, $notifyForm, productData);
          },
          beforeClose: function(){
            quickShop.beforeClose(productData);
          }
        })

      });

    },
    createImageObjects: function($images){
      //split image info
      const image_paths_alts = $images.split('~');

      //Create new array with image objects
      const imageArray = image_paths_alts.map(function(image){
        var imageInfo = image.split('^');
        return {
          path: imageInfo[0],
          alt: imageInfo[1],
          id: imageInfo[2]
        }
      });

      return imageArray;
    },
    beforeOpen: function(productData) {

      //Add image elements before gallery is opened
      quickShop.populateGallery(productData.image_array);

      $('.js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner').empty();
      $('.modal_price, .js-notify-form').show();

      if (productData.image_array.length > 1) {
        $('.js-gallery-modal').addClass('multi-image');
        $('.js-gallery-modal').removeClass('single-image');
        $('.js-gallery-modal').addClass('is-draggable');
      } else {
        $('.js-gallery-modal').addClass('single-image');
        $('.js-gallery-modal').removeClass('multi-image');
      }

    },
    afterContent: function($productForm, $notifyForm, productData) {

      quickShop.retrieveProductInfo(productData);

      var prevNext = false;
      var draggable = false;
      if (productData.image_array.length > 1) {
        prevNext = true;
        draggable = true;
      } else {
        prevNext = false;
        draggable = false;
      }

      //Add main gallery
      $('.js-gallery-modal').flickity({
        "adaptiveHeight": true,
        "wrapAround": "true",
        "cellAlign": "left",
        "draggable": draggable,
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": false,
        "dragThreshold": 10,
        "arrowShape": arrowSize
      });

      

      //Copy form data to modal
      $('.quick-shop__lightbox .js-notify-form').append($notifyForm);
      $('.quick-shop__lightbox .js-product-form').append($productForm);

      //Initiate selectCallback
      if($productForm.hasClass("product_form_options") && $productForm.hasClass("viewed") == false) {
        //If form hasn't been viewed previously, run OptionSelectors function
        new Shopify.OptionSelectors($productForm.data("select-id"),
                                    {
          product: $productForm.data("product"),
          onVariantSelected: selectCallback,
          enableHistoryState: $productForm.data("enable-state")
        });
      } else {

      }

      //Link sold out options when there is more than one option available (eg. S is selected and Yellow option appears as sold out)
      
      const JSONData = $productForm.data('product');
      const productID = productData.section_id;
      const productSection = '.product-' + productID + ' .js-product_section';
      const swatchOptions = $productForm.find('.swatch_options .swatch');
      if (swatchOptions.length > 1){
        Shopify.linkOptionSelectors(JSONData, productSection);
      }
      

      $('.js-quick-shop select[name="id"]').trigger('change');

      utils.initializeTabs();

      $('.js-quick-shop .text-modal-wrap iframe[src*=youtube], .js-quick-shop .text-modal-wrap iframe[src*=vimeo]').mediaWrapper({
        intrinsic: true
      });

      productPage.productSwatches();

    },
    beforeClose: function(productData) {

      const $insertedNotifyForm = $('.quick-shop__lightbox .notify_form');
      const $insertedProductForm = $('.quick-shop__lightbox .product_form');

      //Copy form data back to product loop and add .viewed
      $('.js-quickshop-forms--'+ productData.product_id).append($insertedProductForm);
      $('.js-quickshop-forms--'+ productData.product_id).append($insertedNotifyForm);
      $('.js-quickshop-forms--'+ productData.product_id +' .product_form').addClass('viewed');
      $('.js-quickshop-forms--'+ productData.product_id +' .notify_form').addClass('viewed');

      //Find gallery and carousel
      const $gallery = $('.js-gallery-modal');
      const $carousel = $('.js-gallery-carousel');

      $('.js-gallery-carousel .gallery-cell').off('click');

      //Remove image slides from gallery
      $gallery.flickity( 'remove', $('.gallery-cell', $gallery));

      //Destroy sliders when modal closes
      $gallery.flickity('destroy');
      if ($carousel.hasClass('flickity-enabled')){
        $carousel.flickity( 'remove', $('.gallery-cell', $carousel) );
        $carousel.flickity('destroy');
      } else {
        $carousel.find('.gallery-cell').remove();
      }

      const variantPrice = $('.js-current-price .money').text();
      $('.js-quick-shop-link[data-id=' + productData.product_id + ']').attr('data-initial-modal-price', variantPrice);
      $('.js-current-price, .js-was-price, .js-savings').empty();

    },
    retrieveProductInfo: function(productData){
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        url: "/products/" + productData.handle + ".js",
        success: function(product) {
          //Create new object combining info
          product = $.extend({}, product, productData);

          globalQuickShopProduct = product;
          quickShop.updateVariant(product.variants[0].id.toString(), product);

        }
      });

    },
    updateVariant: function(variant){

      if (globalQuickShopProduct != 'undefined'){

        var product = globalQuickShopProduct;

        $('.js-current-price').html('');
        $('.js-was-price').html('');
        $('.js-savings').html('');

        //Title and Vendor
        $('.js-product-title').html('<a href="'+ product.product_in_collection_url +'" title="'+ product.escaped_title +'">'+ product.title +'</a>');
        $('.js-product-vendor')
        .html('<a href="/collections/vendors?q=' + product.vendor +'">' + product.vendor + '</a>');

        //Product Description
        $('.js-full-description').html(product.full_description);
        $('.js-regular-description').html(product.regular_description);
        var productDetails = '<a href="'+ product.product_in_collection_url +'" class="secondary_button" title="'+ product.escaped_title +' Details">'+ product.details_text +'</a>';
        $('.js-product-details').html(productDetails);

        //Collection banners
        $.each( product.collection_handles, function( value, index ) {
          if (this.toString() == 'new'){
            $('.js-new-banner').html("New");
          }
          if (this.toString() == 'pre-order'){
            $('.js-pre-order-banner').html("Pre-Order");
          }
          if (this.toString() == 'coming-soon'){
            product.price = "Coming Soon";
          }

        });

        if (product.single_variant == 'true'){

          //No variants
          //Sale Banner
          

          //Sale
          if (product.compare_at_price > product.price) {
            $('.js-current-price').addClass('sale');
          } else {
            $('.js-current-price').removeClass('sale');
          }

          //Availability
          if (product.available == false){
            $('.js-sold-out').html("Sold Out");
          } else {
            $('.js-sold-out').html('');
          }

          //Price
          if (product.available == true) {
            $('.js-notify-form').hide();

            if (product.compare_at_price > product.price) {
              $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.variants[0].compare_at_price, product.money_format)  + '</span>');
              $('.js-savings').html("You Save" + ' ' + parseInt(((product.variants[0].compare_at_price - product.variants[0].price) * 100) / product.variants[0].compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.variants[0].compare_at_price - product.variants[0].price, product.money_format) + '</span>)');
            }

            if (product.price == "Coming Soon"){
                $('.js-current-price').html("Coming Soon");
          } else if (product.price) {
            $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.variants[0].price, product.money_format) + '</span>');
          } else {
            $('.js-current-price').html('Free');
                                        }
                                        }

                                        } else {

                                        //Variant loop
                                        for (var i = 0; i < product.variants.length; i++) {

              if (variant == product.variants[i].id.toString()){
                //Sale Banner
                

                //Sale
                if (product.variants[i].compare_at_price > product.variants[i].price) {
                  $('.js-current-price').addClass('sale');
                } else {
                  $('.js-current-price').removeClass('sale');
                }

                //Availability
                if (product.variants[i].available == false){
                  $('.js-sold-out').html("Sold Out");
                } else {
                  $('.js-sold-out').html('');
                }

                //Price
                if (product.variants[i].available == true) {
                  $('.js-notify-form').hide();

                  if (product.variants[i].compare_at_price > product.variants[i].price) {
                    $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price, product.money_format) + '</span>');
                    $('.js-savings').html("You Save" + ' ' + parseInt(((product.variants[i].compare_at_price - product.variants[i].price) * 100) / product.variants[i].compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price - product.variants[i].price, product.money_format) + '</span>)');
                  }

                  if (product.price == "Coming Soon"){
                      $('.js-current-price').html("Coming Soon");
                } else if (product.variants[i].price) {
                  $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].price, product.money_format) + '</span>');
                } else {
                  $('.js-current-price').html('Free');
                                              }
                                              } else {
                                              $('.js-notify-form').show();
                }
              }
            }
          }
        }

      },
        populateGallery: function(image_array){

          //Find gallery and carousel
          const $gallery = $('.js-gallery-modal');
          const $carousel = $('.js-gallery-carousel');

          //Add gallery images based on product info from API
          function addMainGalleryImages(){

            $.each( image_array, function( i, image ){

              var imgPath = image.path;

              var img2048x2048 = imgPath.replace(/(\.[^.]*)$/, "_2048x2048$1").replace('http:', '');
              var alt = image.alt;
              var cellContent;

              if (alt.indexOf("youtube") >= 0){
                cellContent = '<div class="video-container youtube"><div>' + alt + '</div></div>';
              } else if (alt.indexOf("vimeo") >= 0) {
                cellContent = '<div class="video-container vimeo"><div>' + alt + '</div></div>';
              } else {
                cellContent = '<img src="' + img2048x2048 + '" alt="' + alt + '" data-image-id="' + image.id + '" data-index="' + i + '" />';
              }

              var $cellElems = $('<div class="gallery-cell">'+ cellContent +'</div>');
              $('.js-gallery-modal').append($cellElems);
            });

          }

          //Add carousel images based on product info from API
          function addCarouselGalleryImages(){
            $.each( image_array, function( i, image ){
              var imgPath = image.path;
              var carouselSizedImg = imgPath.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');

              var img = '<img src="'+ carouselSizedImg + '" alt="' + escape(image.alt) + '" />';
              var $carouselCellElems = $('<div class="gallery-cell">'+ img +'</div>');
              $carousel.append($carouselCellElems);
            });

            imageFunctions.linkGalleryAndCarousel($gallery, $carousel);

            

          }

          addMainGalleryImages();
          addCarouselGalleryImages();

          imageFunctions.zoom('.js-gallery-modal', false);

        }
    }

/*============================================================================
  Newsletter Popup
==============================================================================*/

    var newsletter_popup = {
    init: function(){
    var popup = Cookies.get('popup');
    var cookie_enabled = true;

    if (cookie_enabled && popup == 'open') {
    return false;
  } else {
    newsletter_popup.open();
  }
  if (cookie_enabled) {
    Cookies.set('popup', 'open', { expires: 30 });
                                 }
                },
                open: function(){
      if (false || $(window).width() > 798) {
        setTimeout( function() {
          $.fancybox.open($('.js-newsletter-popup'), {
            baseClass: 'newsletter__lightbox',
            hash: false,
            infobar : false,
            toolbar: false,
            loop: true,
            smallBtn : true,
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true,
              buttons: [
                "close"
              ]
            }
          });
        },
                   2*1000);
      }
    }
  }

/*============================================================================
  Color Swatch Filter
==============================================================================*/
  var colorSwatch = {
    init: function(){
      if($('.js-product_section').length > 0){
        var $product_json = $('.js-product_section .product_form').data('product');
        var $product_media = $product_json.media;
        $('body').on('change', '.swatch :radio', function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          var gallery_cell = '';
          var optionName = $(this).data('option');
          
          if(optionName == 'Material'){
            if(colorSwatch.optionValidator($product_json)){
              if($(window).width() < 798){
                $('.js-product-gallery').flickity('destroy');
                $('.js-product-gallery').empty();
              }else{            
                $('.js-product-gallery').empty();
              }
              $product_media.forEach(function(val,index){
                var img_width = val.preview_image.width;
                var img_height = val.preview_image.height;
                var img_100x = val.src.replace(/(\.[^.]*)$/, "_100x$1").replace('http:', '');
                var img_200x = val.src.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
                var img_400x = val.src.replace(/(\.[^.]*)$/, "_400x$1").replace('http:', '');
                var img_600x = val.src.replace(/(\.[^.]*)$/, "_600x$1").replace('http:', '');
                var img_800x = val.src.replace(/(\.[^.]*)$/, "_800x$1").replace('http:', '');
                var img_1200x = val.src.replace(/(\.[^.]*)$/, "_1200x$1").replace('http:', '');
                var img_2000x = val.src.replace(/(\.[^.]*)$/, "_2000x$1").replace('http:', '');

                if(val.alt.includes(optionValue)){
                  gallery_cell = '<div class="gallery-cell" data-thumb="" data-title="' + val.alt + '" data-image-width="' + img_width + 'px' +'"><div class="image__container" style="max-width: ' + img_width + 'px' +'">';
                  gallery_cell += '<img src="' + img_100x + '" alt="' + val.alt + '" class=" lazyload blur-up" data-index="' + val.position + '" data-image-id="' + val.id + '" data-sizes="auto" data-aspectratio="' + val.aspect_ratio + '" data-src="' + img_2000x + '" srcset="' + img_200x + ' 200w,' + img_400x + ' 400w,' + img_600x + ' 600w,' + img_800x + ' 800w,' + img_1200x + ' 1200w,' + img_2000x + ' 2000w' + '" />';
                  gallery_cell += '</div></div>';
                  $('.js-product-gallery').append(gallery_cell);
                }
              });
            }

            if($(window).width() < 798){
              var $js_product_gallery = $('.js-product-gallery').flickity({
                "adaptiveHeight": true,
                "wrapAround": "true",
                "cellAlign": "left",
                "draggable": true,
                "contain": true,
                "imagesLoaded": true,
                "lazyLoad": 2,
                "pageDots": true,
                "prevNextButtons": true,
                "autoPlay": true ? 6000 : false,
                "dragThreshold": 10,
                "arrowShape": arrowSize
              });
            }
          }
        });
      }
    },
    optionValidator: function($product_json){
      var options = $product_json.options;
      var material = false;
      if(options.length > 0){
        options.forEach(function(val, index){
          if(val == 'Material'){
          	material = true;
          }
        })
      }
      return material;
    }
  }
  
  //document ready
  $(function() {

    var oldFlickityCreate = window.Flickity.prototype._create;

    window.Flickity.prototype._create = function(){
      var that = this;
      if(this.element.addEventListener){
        this.element.addEventListener('load', function(){
          that.onresize();
        }, true);
      }
      this._create = oldFlickityCreate;
      return oldFlickityCreate.apply(this, arguments);
    };

    objectFitImages();
    header.loadMegaMenu();
    header.init();
    
    searchAutocomplete.init();
    
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    videoSection.init();
    gallery.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    cart.init();
    mapFunction.init();


    productPage.initializeQuantityBox();
    productPage.init();
    productPage.relatedProducts();

    recentlyViewed.init();
    colorSwatch.init();

    // Setup a timer
    var resizeTimeout;

    // Listen for resize events
    window.addEventListener('resize', function ( event ) {

      // If timer is null, reset it to 66ms and run your functions.
      // Otherwise, wait until timer is cleared
      if ( !resizeTimeout ) {
        resizeTimeout = setTimeout(function() {

          // Reset timeout
          resizeTimeout = null;

          // Run our resize functions
          if($(window).width() <= 798) {
            cart.init();
            header.unload();
            header.init();
          }

        }, 66);
      }
    }, false);

    //Lightbox default options
    //https://fancyapps.com/fancybox/3/docs/#options
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'fade';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function(instance, slide) {
      if (instance.current.type == 'image'){
        slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
      }
      if (instance.group.length > 1){
        slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
      }
    }

    window.localStorage.setItem('collection-cols', 'four-column-view');

    //backwards compatibility with custom lightboxes
    $('.lightbox[rel="gallery"]').fancybox();

    //Search input hiding
    //get current input
    var currentValue = $(".search_form input[name='q']").val()
    //return amount without *
    if ($(".search_form input[name='q']").length > 0){
      $(".search_form input[name='q']").val( currentValue.replace('*', '') );
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
    });

    $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
    });

    $('input, select, textarea').on('focus blur', function(event) {
      $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });

    //Collection sidebar filter
    //Check the checkbox values

    $('body').on('change', '.toggle_list input', function(){
      $('.selected-tag-group').empty();
      $('.toggle_tag-list li').each(function(){
        var $input = $(this).find('input');
        if($input.prop('checked')){
          var selected_tag = '<div class="selected-tag-list"> <span class="selected-tag-list-name">' + $input.data('name') + '</span> <a href="#" data-tag-val="' + $input.val() + '">X</a></div>';
          $('.selected-tag-group').append(selected_tag);
        }
      });
      
      $('.toggle_type-list li').each(function(){
        var $input = $(this).find('input');
        if($input.prop('checked')){
          var selected_tag = '<div class="selected-type-list"> <span class="selected-type-list-name">' + $input.data('name') + '</span> <a href="#" data-tag-val="' + $input.val() + '">X</a></div>';
          $('.selected-tag-group').append(selected_tag);
        }
      });

      collectionquickFilter.init(window.localStorage.getItem('collection-cols'));
      $("html, body").animate({
        scrollTop: ($('.collection-matrix').offset().top) - 200
      }, 500);
    })

    $('body').on('keyup change', 'input.side_query', function(){
      if($(this).val().length >= 3 || $(this).val().length == 0){
        collectionquickFilter.init(window.localStorage.getItem('collection-cols'));
        $("html, body").animate({
          scrollTop: ($('.collection-matrix').offset().top) - 200
        }, 500);
      }
    })

    $('body').on('click', '.selected-tag-list a', function(e){
      e.preventDefault();
      var tag_name = $(this).data('tag-val');
      $(this).parent().remove();
      $('.toggle_tag-list li').each(function(){
        var $input = $(this).find('input');
        if(tag_name == $input.val()){
          $input.prop('checked', false);
        }
      });
      collectionquickFilter.init(window.localStorage.getItem('collection-cols'));
    });
    
    $('body').on('click', '.selected-type-list a', function(e){
      e.preventDefault();
      var type_name = $(this).data('tag-val');
      $(this).parent().remove();
      $('.toggle_type-list li').each(function(){
        var $input = $(this).find('input');
        if(type_name == $input.val()){
          $input.prop('checked', false);
        }
      });
      collectionquickFilter.init(window.localStorage.getItem('collection-cols'));
    })

    $('body').on('click', '.clear_filter-option', function(){
      $('.selected-tag-group').empty();
      $('.toggle_list li').each(function(){
        var $input = $(this).find('input');
        $input.prop('checked', false);
      });
      $('.side_query').val('');
      collectionquickFilter.init(window.localStorage.getItem('collection-cols'));
    })

    //collection grid columns view
    $('body').on('click', '.collection-grid-view a,.sidebar-grid-selector ul a', function(e){
      e.preventDefault();
      $('.collection-grid-view li').removeClass('active');
      $(this).closest('li').addClass('active');
      var grid_val = $(this).data('row');
      if(grid_val == 1){
        collectionquickFilter.init('one-column-view');
        window.localStorage.setItem('collection-cols', 'one-column-view');
      }else if(grid_val == 2){
        collectionquickFilter.init('two-column-view');
        window.localStorage.setItem('collection-cols', 'two-column-view');
      }else if(grid_val == 3){
        collectionquickFilter.init('three-column-view');
        window.localStorage.setItem('collection-cols', 'three-column-view');
      }else if(grid_val == 4){
        $('body').removeClass('one-column-view two-column-view three-column-view four-column-view');
        window.localStorage.setItem('collection-cols', 'four-column-view');
      }
    })

    $('body').on('click', '[data-reset-filters]', function(){
      collectionSidebarFilter.clearAllFilters();
    });

    $('body').on('click', '[data-clear-filter]', function(){
      var selectedOption = $(this).parents('.filter-active-tag');
      collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });

    $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
    });

    $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
    });

    

    var touchStartPos = 0;

    //Detecting swipe vs tap
    $(document).bind("touchstart", function (e) {
      touchStartPos = $(window).scrollTop();
    }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
        e.preventDefault;
      }
    });

    $('body').on('click', '.sidebar .parent-link--false', function(e) {
      e.preventDefault();
      $menu = $(this).parent('li');
      $menu.find('.menu-toggle').toggleClass('active');
      $menu.find('ul').slideToggle();
    });

    

    if(window.location.pathname.indexOf('/comments') != -1) {
      $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
    }

    $('body').on('mouseenter', '.icon-search', function() {
      $('.search-terms').focus();
    });

    $('body').on('click', '.icon-search', function() {
      $('input.search-terms').focus();
    });

    $('body').on('click', '.search-submit', function() {
      $(this).parent().submit();
    });

    if ($(window).width() > 798) {
      $(".animate_right").waypoint(function() {
        $(this.element).addClass("animated fadeInRight");
      }, { offset: '70%' });
      $(".animate_left").waypoint(function() {
        $(this.element).addClass("animated fadeInLeft");
      }, { offset: '70%' });
      $(".animate_up").waypoint(function() {
        $(this.element).addClass("animated fadeInUp");
      }, { offset: '70%' });
      $(".animate_down").waypoint(function() {
        $(this.element).addClass("animated fadeInDown");
      }, { offset: '70%' });
    }

    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: false,
      imagesLoaded: true,
      arrowShape: arrowSize,
      lazyLoad: 2
    });

    utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
    utils.createAccordion('.footer_menu', 'h6', 'ul');
    utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
    utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

    utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
    utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

    utils.initializeTabs();
    utils.resizeActionButtons();
    faqAccordion.init();

    $(window).on('resize', function() {
      utils.resizeActionButtons();
    });

    //Sidebar toggle check
    if ($(window).width() <= 798) {
      utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
    }

    $('body').on('click', '.menu-toggle', function(e) {
      var $content = $(this).next('ul');
      $content.slideToggle();
      $(this).toggleClass('active');
      $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });

    if ($(window).width() >= 959) {
      var modal_width = '870px';
      if($(window).width() >= 1200 || $('html').hasClass('ie')) {
        modal_width = '1110px'
      }
    }

    

    //Terms of service settings for minicart
    

    


    
    imageFunctions.showSecondaryImage();
    

    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function() {
      var $cf = $(this);
      $cf.on('submit', function (e) {
        if($('input[name="challenge"]', $cf).val() !== "true") {
          $.ajax({
            type: $cf.attr('method'),
            url: $cf.attr('action'),
            data: $cf.serialize(),
            success: function (data) {
              $cf.fadeOut("slow", function(){
                $cf.prev('.message').html("Thank you for joining our mailing list!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $cf).val('true');
              $cf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    $('.maps').click(function () {
      $('.maps iframe').css("pointer-events", "auto");
    });

    
    enableLoadMoreProducts();
    

    

    

    

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

    function ajaxSubmitCart(cart) {
      $cart = cart;
      $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $cart.serialize(),
        success: function (data) {
          refreshCart(data);
        }
      });
    }

    function ajaxUpdateCart(lineID, quantity, parent) {
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: quantity, line: lineID },
        success: function (data) {
          refreshCart(data);

          var lineIDIndex = lineID - 1;

          //check to see if there are correct amount of products in array
          if (typeof data.items[lineIDIndex] === "undefined"){
            var updated_quantity = 0;
          } else {
            var updated_quantity = data.items[lineIDIndex].quantity;
          }

          if(quantity > 0 && quantity != updated_quantity) {
            if (updated_quantity == 1) {
              items_left_text = "item left";
            } else {
              items_left_text = "items left";
            }

            $('.warning--quantity').remove();

            var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
            parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
            parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
          } else if (parent.is('#cart_form')) {
            $("#cart_form").submit();
          }
        }
      });
    }

    function refreshCart(cart) {

      // We make another ajax call to get cart items data from liquid. In this case we can get collections for each product in the cart.
      $.ajax({
        type: 'GET',
        url: '/cart?view=ajax',
        success: function(data) {
          const cartDataFromLiquid = JSON.parse(data);

          $(".header-cart-count").remove();
          var $cartBtn = '<span class="header-cart-count"></span>';
          var cart_items_html = "";
          var cart_action_html = "";
          var cart_savings_html = "";
          var $cart = $(".cart_content form");
          var discounted_price_total = 0;
          var total_savings = 0;
          var gift_id = '';
          var gift_added = true;

          

          if(cart.item_count == 1){
            if(cart.items[0].id == gift_id){
              $('.js-cart_content__form').addClass('hidden');
              $('.js-empty-cart__message').removeClass('hidden');
              return false;
            }
          }

          if (cart.item_count == 0) {
            $('.js-empty-cart__message').removeClass('hidden');
            $('.js-cart_content__form').addClass('hidden');
          } else {

            $('a.header-cart-icon').append($cartBtn);

            $('.js-empty-cart__message').addClass('hidden');
            $('.js-cart_content__form').removeClass('hidden');

            $.each(cart.items, function(index, item) {

              let gtmItem = cartDataFromLiquid.find(itemFromLiquid => itemFromLiquid.line_item_key === item.key);
              delete gtmItem.line_item_key;

              var line_id = index + 1;
              if(item.id == gift_id){ gift_added = false; }
              cart_items_html += `<li class="cart_item clearfix" data-gtm-item='${JSON.stringify(gtmItem)}'>` +
                  '<div class="cart_image-wrapper"><a href="' + item.url +'">';
              if (item.image) {
                cart_items_html += '<div class="cart_image lazyload" data-bgset="' + item.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '') + '">' +
                    '<img src="' + item.image.replace(/(\.[^.]*)$/, "_180x$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                    '</div></a></div>';
              }

              cart_items_html += '<div class="cart_item-content"><div class="cart_item__title"><div class="item_title">' + item.product_title + '</div></div>';

              cart_items_html += '<div class="item-price">';

              

              cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>' + '</div>';

              if(item.id != gift_id){
                cart_items_html += '<div class="cart_item-quantity-wrapper"><div class="product-quantity-title item_title">Quantity</div><div class="product-quantity-box">' +
                    '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.37 1"><g data-name="Group 222" transform="translate(396.575 -1663.487) rotate(90)"><path id="Path_113" data-name="Path 113" d="M11.779,1.466v7.37" transform="translate(1652.208 387.24)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="1"/></g></svg></span>' +
                    '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
                    '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.37 8.37"><g data-name="Group 223" transform="translate(-1658.304 -388.205)"><path id="Path_113" data-name="Path 113" d="M11.779,1.466v7.37" transform="translate(1650.709 387.24)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="1"/><path id="Path_114" data-name="Path 114" d="M0,0V7.37" transform="translate(1658.804 392.39) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="1"/></g></svg></span>' +
                    '</div>' +
                    '</div>';
              }

              if(item.options_with_values.length > 0) {
                $.each(item.options_with_values, function(title, value) {
                  if (!value.name.includes('Title')) {
                    cart_items_html += '<div class="item_variant-wrapper"><div class="item_option-title item_title">' + value.name  + '</div><div class="item_option-value">' + value.value + '</div></div>';
                  }
                });
              }

              if(item.properties){
                $.each(item.properties, function(title, value) {
                  if (value) {
                    cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
                  }
                });
              }

              cart_items_html += '<div class="line-item-remove"><a href="#" class="item_remove" data-line-id="' + line_id + '"><svg xmlns="http://www.w3.org/2000/svg" width="15.309" height="18.743" viewBox="0 0 15.309 18.743"><g transform="translate(0)" opacity="0.4"><path id="Path_108" data-name="Path 108" d="M15.261,4.19l-.414-1.241a1.154,1.154,0,0,0-1.1-.79H10.272V1.027A1.027,1.027,0,0,0,9.246,0H6.061A1.028,1.028,0,0,0,5.035,1.027V2.159H1.557a1.154,1.154,0,0,0-1.1.79L.047,4.19A.929.929,0,0,0,.928,5.412H1.36l.952,11.773A1.7,1.7,0,0,0,4,18.744h7.5a1.7,1.7,0,0,0,1.688-1.558L14.14,5.412h.24a.929.929,0,0,0,.881-1.223ZM6.133,1.1H9.174V2.159H6.133Zm5.96,16a.6.6,0,0,1-.593.548H4a.6.6,0,0,1-.593-.548L2.462,5.412H13.038ZM1.163,4.314,1.5,3.3a.057.057,0,0,1,.054-.039H13.751A.057.057,0,0,1,13.8,3.3l.339,1.017Zm0,0" transform="translate(0)"/><path id="Path_109" data-name="Path 109" d="M268.816,176.572h.029a.549.549,0,0,0,.548-.521l.516-9.9a.549.549,0,0,0-1.1-.057L268.3,176A.549.549,0,0,0,268.816,176.572Zm0,0" transform="translate(-258.475 -159.515)"/><path id="Path_110" data-name="Path 110" d="M106.335,176.057a.549.549,0,0,0,.548.519h.03a.549.549,0,0,0,.518-.578l-.54-9.9a.549.549,0,0,0-1.1.06Zm0,0" transform="translate(-101.922 -159.517)"/><path id="Path_111" data-name="Path 111" d="M194.8,176.575a.549.549,0,0,0,.549-.549v-9.9a.549.549,0,0,0-1.1,0v9.9A.549.549,0,0,0,194.8,176.575Zm0,0" transform="translate(-187.143 -159.517)"/></g></svg></a></div>';

              cart_items_html += '</div>';


            });

            cart_action_html += '<span class="right"><span>Total <span class="vat-name">(VAT included)</span></span></span><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span>';

            if(total_savings > 0 ) {
              cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
                  '<span>Total Savings</span>';
            } else {
              cart_savings_html = "";
            }
          }

          $('.js-cart_items').html(cart_items_html);
          $('.js-cart_subtotal').html(cart_action_html);
          $('.js-cart_savings').html(cart_savings_html);

        },
        error: function(x, t, m) {
          console.log(x);
          console.log(t);
          console.log(m);
        }
      });

    }

    function addtoCartAction(){
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          refreshCart(cart);
          if($('body').hasClass('fancybox-active')) {
            $.fancybox.close();
          }

          // $('.js-side-cart').addClass('side-cart-opened');
          // $('body').addClass('popup-opened');

          //block scrolling on mobile
          if ($(window).width() <= 798) {
            var $cart_container = $(this).parent();
            if($cart_container.hasClass('active_link')) {
              $('body').addClass('blocked-scroll');
            } else {
              $('body').addClass('blocked-scroll');
            }
          }
        }
      });
    }
    
    $('body').on("change", "#cart_form input.quantity", function() {
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
    });

    $('body').on("change", ".cart_content input.quantity", function() {
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
    });
    
    

    $('body').on('click', '.item_remove', function(e){
      e.preventDefault();
      var line_id = $(this).data('line-id');
      ajaxUpdateCart(line_id, 0, $(this).parents('form'));
      $(this).closest('.cart_item').remove();
    });

    
    $(document).on('click', '.ajax-submit,input.iwishBuyBtn', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      let gift_id = '';
      var gift_added = false;
      
      

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          var cart_items = '';

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
          
          if(gift_id != ''){
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              success: function(cart) {
                $.each(cart.items, function(index, item) {
                  if(item.id == gift_id){console.log(gift_id);
                    gift_added = true;
                  }
                });
                if(gift_added){
                  addtoCartAction();
                }else{
                  $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: {
                      quantity: 1,
                      id: gift_id
                    },
                    success: function(itemData) {
                      addtoCartAction()
                    }
                  });
                }
              }
            });
          }else{
          	addtoCartAction();
          }
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Bag").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
    

    productPage.productSwatches();
    
	// Wishlist add to cart
    $(document).on('click', 'input.iwishBuyBtn', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      let gift_id = '';
      var gift_added = false;
      
      

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          
        },
        success: function(itemData) {
          var cart_items = '';          
          if(gift_id != ''){
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              success: function(cart) {
                $.each(cart.items, function(index, item) {
                  if(item.id == gift_id){console.log(gift_id);
                    gift_added = true;
                  }
                });
                if(gift_added){
                  addtoCartAction();
                }else{
                  $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: {
                      quantity: 1,
                      id: gift_id
                    },
                    success: function(itemData) {
                      addtoCartAction()
                    }
                  });
                }
              }
            });
          }else{
          	addtoCartAction();
          }
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Bag").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
    
    //bundle add to cart functionality
  $(document).on('click', '.ajax-bundle-submit', function(e){
      e.preventDefault();
      var parent = $(this).closest('.product_form');
      var $addToCartBtn = parent.find('.add_to_cart');
      var items = [];
      var discountCode = parent.data('discount-code');
      var bundleCount = $('.bundle_list-cell').length;
      var i = 0;
      var charmSelect = $('[name="charmConnector"]');
      $.each(parent.find('.bundle_list-cell'), function(){
        var $input = $(this).find('input[bundle-variant-checkbox]');
        var variant_id = $input.val();
        var variant_quantity = $input.data('quantity');
        if($input.prop('checked')){
          var item = {
            quantity: variant_quantity,
            id: variant_id
          };

          items.push(item);
          
          i++;
        }
      });

      if(items.length > 0){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: {
            items: items
          },
          dataType: 'json',
          error: function(data) {
            console.log('product unavailable');
          },
          beforeSend: function() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
          },
          success: function (data) {
            $addToCartBtn.find('.checkmark').addClass('checkmark-active');
            var cart_items = '';

            window.setTimeout(function(){
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);
            
            if(charmSelect.length > 0){
              if(charmSelect.val() != '' && $('[charm-variant-checkbox]').prop('checked')){
                $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'post',
                  data: {
                    quantity: 1,
                    id: charmSelect.val()
                  },
                  success: function(itemData) {
                    addtoCartAction();
                  }
                });
              }else{
              	addtoCartAction();
              }
            }else{
              addtoCartAction();
            }
          },
          cache: false
        });
      }else{
      	parent.find('.bundle_list-wrap').addClass('no-selected-bundles');
      }
    });
    
    //charm add to cart functionality
  $(document).on('click', '.ajax-submit-charm', function(e){
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      var charmSelect = $('[name="charmConnector"]');
      

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: $addToCartForm.serialize(),
        dataType: 'json',
        error: function(data) {
          console.log('product unavailable');
        },
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function (data) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
          
          if(charmSelect.val() != '' && $('[charm-variant-checkbox]').prop('checked')){
      		$.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              data: {
                quantity: 1,
                id: charmSelect.val()
              },
              success: function(itemData) {
                addtoCartAction();
              }
            });
          }else{
          	addtoCartAction();
          }
        },
        cache: false
      });
    
    });

  });

  //Used for cart functionality
  function htmlEncode(value){
    if (value) {
      return $('<div/>').text(value).html();
    } else {
      return '';
    }
  }

  //Check if device is touch-enabled
  function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  };

  $(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
    }

    utils.resizeActionButtons();

  });

  $(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

  });

  $(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

  });

  $(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    
    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.init();
    }
    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.productSwatches();
      productPage.relatedProducts();
      recentlyViewed.init();
      
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
      searchAutocomplete.init();
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }
  });


  $(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

  });

  $(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

  $(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
  });